import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Asset, AssetsGroup} from "@nolimitcity/slot-game/bin/asset/Asset";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";

export class SpineViewUtils {
    public static init(assetsGroup: AssetsGroup[], assetLoader: AssetLoader): void {
        const style = new PIXI.TextStyle({
            dropShadowAngle: 1.4,
            dropShadowBlur: 2,
            dropShadowColor: "#dd1d1d",
            dropShadowDistance: 8,
            fill: "#ece4e4",
            fontSize: 16
        });
        const view = new View();
        NolimitApplication.addLayer("SpineView", view);
        let xCounter: number = 0;
        let yCounter: number = 0;
        let maxWidth: number = 0;
        let width: number = 0;
        const text = new PIXI.Text("close", style);
        text.interactive = true;
        text.position.set(-110, 50);
        text.on('pointerdown', () => {
            view.visible = false;
        });
        view.spineContainer.addChild(text);
        assetsGroup.forEach((obj: AssetsGroup) => {
            if (obj.name === "spine") {
                obj.assets.forEach((spineAsset: Asset, index: number) => {
                    const text = new PIXI.Text(spineAsset.name, style);
                    text.interactive = true;
                    text.on('pointerdown', () => {

                        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(assetLoader.getSpineAsset(text.text));
                        view.animationContainer.removeChildren();
                        view.skinContainer.removeChildren();

                        spine.stateData.skeletonData.skins.forEach((obj : PIXI.spine.core.Skin, index: number) => {
                            const animText = new PIXI.Text(obj.name, style);
                            view.skinContainer.addChild(animText);
                            animText.position.set(0, index * animText.height);
                            animText.interactive = true;
                            animText.on('pointerdown', () => {
                                spine.skeleton.setSkinByName(animText.text);
                            });
                        });

                        spine.stateData.skeletonData.animations.forEach((obj, index: number) => {
                            const animText = new PIXI.Text(obj.name + "  time: "+obj.duration, style);
                            view.animationContainer.addChild(animText);
                            animText.position.set(0, index * animText.height);
                            animText.interactive = true;
                            animText.on('pointerdown', () => {
                                view.actionView.removeChildren();
                                view.actionView.addChild(spine);
                                spine.state.setAnimation(0, obj.name, false);
                            });
                        });
                    });
                    view.spineContainer.addChild(text);
                    text.position.set((xCounter * width), yCounter * text.height);
                    yCounter++;
                    maxWidth = Math.max(maxWidth, text.width);
                    if (text.position.y >= 600) {
                        xCounter++;
                        yCounter = 0;
                        width = maxWidth;
                    }

                });
            }
        });
        view.animationContainer.position.set(view.spineContainer.x + view.spineContainer.width + 30, 8);
        view.skinContainer.position.set(200, 8);
        view.actionView.position.set(645, 300);
    }

}

export class View extends PIXI.Container implements StageLayer {
    public spineContainer: PIXI.Container;
    public animationContainer: PIXI.Container;
    public skinContainer: PIXI.Container;
    public actionView: PIXI.Container;

    constructor() {
        super();
        this.init();
    }

    public init(): void {
        this.spineContainer = new PIXI.Container();
        this.animationContainer = new PIXI.Container();
        this.skinContainer = new PIXI.Container();
        this.actionView = new PIXI.Container();
        this.addChild(this.actionView, this.spineContainer, this.skinContainer, this.animationContainer,);
        this.spineContainer.position.set(-135, 8);
    }

}